import { render, staticRenderFns } from "./baby_granary.vue?vue&type=template&id=22e1c2d6&scoped=true"
import script from "./baby_granary.vue?vue&type=script&lang=js"
export * from "./baby_granary.vue?vue&type=script&lang=js"
import style0 from "./baby_granary.vue?vue&type=style&index=0&id=22e1c2d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1c2d6",
  null
  
)

export default component.exports